import React from 'react';
import { ColDef } from 'ag-grid-community';
import TableActionButtons from '../components/common/TableActionButtons';

export function getActionColumn<T>(options: {
  viewUrl?: (row: T) => string; // ✅ Function to generate view URL
  editUrl?: (row: T) => string; // ✅ Function to generate edit URL
  viewClick?: (row: T) => void;
  editClick?: (row: T) => void;
  onDelete?: (row: T, rowIndex?:number|null) => void;
  additionalActions?: (row: T, rowIndex?:number|null) => React.ReactNode; // ✅ Optional additional actions
  width?: number; // Optional width for the action column
}): ColDef<T> {

  return {
    headerName: 'Actions',
    colId: 'actions',
    cellRenderer: (params: any, i:any) => {
      const rowIndex = params.node?.id != null ? parseInt(params.node.id, 10): null;
      const row = params.data as T;
      return (
        <div className="flex items-center space-x-2">
          <TableActionButtons  
            viewUrl={options.viewUrl ? `${options.viewUrl(row)}` : undefined}
            editUrl={options.editUrl ? options.editUrl(row) : undefined}
            viewClick={options.viewClick ? () => options.viewClick?.(row):undefined}
            editClick={options.editClick ? () => options.editClick?.(row):undefined}
            onDelete={options.onDelete ? () => options.onDelete?.(row,rowIndex):undefined}
          />
          {options.additionalActions?.(row,rowIndex)} {/* Render additional actions if provided */}
        </div>
      );
    },
    width: options?.width || 150,
    pinned: 'right',
    sortable: false,
    filter: false,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  };
}
